<template>
  <div v-show="error">
    <component
      :is="errorComponent"
      :error="errorVal"
    />
  </div>
</template>

<script>
import PaymentRulesFactError from './payment-rules-fact-error.vue'
import PaymentCustomerNotFound from './payment-customer-not-found-error.vue'
import PaymentTransactionNotFoundError from './payment-transaction-not-found-error.vue'
import PaymentTransactionStatusError from './payment-transaction-status-error.vue'
import PaymentAccessControlError from './payment-access-control-error.vue'
import PaymentRateLimitExceededError from './payment-rate-limit-exceeded-error.vue'
import GeneralError from './general-error.vue'

export default {
  name: 'square-payments-payment-init-error',
  props: {
    error: {
      type: [Object, Error],
      required: false,
      default: () => false
    }
  },
  computed: {
    errorVal: function() {
      return (typeof this.error === 'boolean') ? {} : this.error
    },
    errorCategory: function() {
      if (this.error) {
        return this.error.category
      }
      return null
    },
    errorComponent: function() {
      console.debug('errorCategory', this.errorCategory)
      switch (this.errorCategory) {
      case 'access-control':
        return PaymentAccessControlError
      case 'rate-limit-exceeded':
        return PaymentRateLimitExceededError
      case 'TransactionNotFoundError':
        return PaymentTransactionNotFoundError

      case 'transaction':
        return PaymentTransactionStatusError

      case 'RulesFactError':
        return PaymentRulesFactError

      case 'CustomerNotFoundError':
        return PaymentCustomerNotFound

      default:
        return GeneralError
      }
    }
  }
}
</script>
